export default "__VITE_ASSET__BAX_8vF8__"